<template>
  <div>
    <el-dialog
      title="作废"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
      v-dialogDrag
      @close="close"
    >
      <el-form
        :model="dataObj"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-position="right"
        label-width="90px"
      >
        <el-form-item label="作废原因" prop="invalidText">
          <el-input
            type="textarea"
            :rows="4"
            v-model="dataObj.invalidText"
            placeholder="请输入"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close" v-preventReClick="5000" :disabled="disabled"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="checkAdd('ruleForm')"
          v-preventReClick="5000"
          :disabled="disabled"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 退款单作废弹窗
 * 功能：按 platform 区分调用 Amazon/eBay 作废接口，填写作废原因后批量作废。
 * 备注：组件 name 为 "add"，疑似复制残留命名。
 */
import { amazonVoidOrder, ebayVoidOrder } from "@/api/user";
export default {
  name: "add",
  props: {
    refundIds: {
      type: Array,
      default: () => {
        return [];
      },
    },
    platform: {
      type: Number,
      default: () => {
        return 1;
      },
    },
  },
  data() {
    return {
      // 按钮禁用状态（定义了未用）
      disabled: false,
      // 弹窗显示状态
      dialogFormVisible: true,
      // 作废提交数据（退款单单号列表/作废原因）
      dataObj: {
        refundIds: [],
        invalidText: "",
      },
      rules: {
        invalidText: [
          {
            required: true,
            message: "请填写作废原因",
            trigger: "blur",
          },
        ],
      },
    };
  },

  methods: {
    /** 关闭弹窗并通知父组件 */
    close() {
      this.dialogFormVisible = false;
      this.$emit("isShowEdit");
    },
    /** 校验表单后按平台调用作废接口，成功后关闭弹窗并刷新列表
     * @param {String} formName 表单 ref 名称
     */
    checkAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataObj.refundIds = this.refundIds;
          if (this.platform === 1) {
            amazonVoidOrder(this.dataObj).then((result) => {
              if (result.code == 200) {
                this.dialogFormVisible = false;
                this.$message.success("操作成功");
                this.$emit("getList");
              }
            });
          } else {
            ebayVoidOrder(this.dataObj).then((result) => {
              if (result.code == 200) {
                this.dialogFormVisible = false;
                this.$message.success("操作成功");
                this.$emit("getList");
              }
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>